export default __webpack_public_path__ + "static/media/Login_form_img_1.c134c8a1.svg";